import { createContext } from 'react';

const FormulaireValidateur = createContext({});

export default FormulaireValidateur;
